import { useState } from "react";
import type { FaqItem } from "@/mocks/site";

interface FaqAccordionProps {
  items: FaqItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200/70 overflow-hidden rounded-lg border border-background-200/70 bg-background-100">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-200 hover:bg-background-200/50 cursor-pointer"
              >
                <span className="flex items-start gap-3">
                  <span className="mt-0.5 font-heading text-sm font-bold text-accent-600">
                    Q{String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="font-heading text-[15px] font-semibold text-foreground-900">
                    {item.q}
                  </span>
                </span>
                <i
                  className={`ri-add-line shrink-0 text-xl text-accent-500 transition-transform duration-300 ${
                    isOpen ? "rotate-45" : ""
                  }`}
                />
              </button>
            </h3>
            <div
              className={`grid transition-all duration-300 ease-out ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-5 pb-5 pl-[3.4rem] text-sm leading-relaxed text-foreground-600">
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}